const DeliveryType = {
    CUSTOM: 'custom',
    APARTMENT: 'apartment',
    HOME: 'home',
    HOME_WITH_ROOFTOP: 'home-with-rooftop',
    COUNTERVISIT: 'countervisit',
    SWIMMING_POOL: 'swimming-pool',
    ROOFING: 'roofing',
    GARDEN: 'garden',
    WATERING: 'watering',
    CRAWLSPACE: 'crawlspace',
    GARDEN_WATERING: 'garden-watering',
    VEFA_LIFTING_RESERVATION: 'vefa-lifting-reservation',
    VEFA_HOME_BULKHEAD: 'vefa-home-bulkhead',
    VEFA_HOME_PRE_DELIVERY: 'vefa-home-pre-delivery',
    VEFA_HOME_RECEPTION_DELIVERY: 'vefa-home-reception-delivery',
    VEFA_APARTMENT_BULKHEAD: 'vefa-apartment-bulkhead',
    VEFA_APARTMENT_PRE_DELIVERY: 'vefa-apartment-pre-delivery',
    VEFA_APARTMENT_RECEPTION_DELIVERY: 'vefa-apartment-reception-delivery',
    MOISTURE_CHECK: 'moisture-check',
    DELIVERY_ASSISTANCE_COMMON_PART: 'delivery-assistance-common-part',
    CCMI_FOUNDATION: 'ccmi-foundation',
    CCMI_BIG_WORK: 'ccmi-big-work',
    CCMI_BULKHEAD: 'ccmi-bulkhead',
    CCMI_COPE: 'ccmi-cope',
    CCMI_RECEPTION_DELIVERY: 'ccmi-reception-delivery',
    CCMI_SERENITY_PACK: 'ccmi-serenity-pack',
    CRACKS_CHECK: 'cracks-check',
    FOLLOW_UP_CONSTRUCTION: 'follow-up-construction',
    FOLLOW_UP_CONSTRUCTION_SITE_ONE_MONTH: 'follow-up-construction-site-one-month',
    FOLLOW_UP_CONSTRUCTION_SITE_THREE_MONTHS: 'follow-up-construction-site-three-months',
    FOLLOW_UP_CONSTRUCTION_SITE_SIX_MONTHS: 'follow-up-construction-site-six-months',
    FOLLOW_UP_CONSTRUCTION_SITE_ALL_INCLUDED: 'follow-up-construction-site-all-included',
    RECEPTION_CONSTRUCTION_SITE: 'reception-construction-site',
    APARTMENT_INVENTORY_FURNISHED: 'apartment-inventory-furnished',
    APARTMENT_INVENTORY_NOT_FURNISHED: 'apartment-inventory-not-furnished',
    HOME_INVENTORY_FURNISHED: 'home-inventory-furnished',
    HOME_INVENTORY_NOT_FURNISHED: 'home-inventory-not-furnished',
    GO_NO_GO_HOME: 'go-no-go-home',
    GO_NO_GO_APARTMENT: 'go-no-go-apartment'
};

module.exports = DeliveryType;